import { render, staticRenderFns } from "./ScoreRow.vue?vue&type=template&id=1bfc0194&scoped=true"
import script from "./ScoreRow.vue?vue&type=script&lang=js"
export * from "./ScoreRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc0194",
  null
  
)

export default component.exports